import { post, get, getToken, postFormData } from './request'

export const apiCourseList = (p) => get('/api-web/course-ys/course-list', p)

export const apiTeacherList = (p) => get('/api-web/course-ys/teacher-list', p)

export const apiTeacherDetail = (p) => get('/api-web/course-ys/teacher-detail', p)

export const apiCourseDetial = (p) => get('/api-web/course-ys/course-info', p)

export const apiChapterList = (p) => get('/api-web/course-ys/chapter-list', p)

export const apiCourseRecomend = (p) => get('/api-web/course-ys/course-prom', p)

export const apiChapterDetail = (p) => get('/api-web/course-ys/chapter-info', p)

export const apiChapterLike = (p) => get('/api-web/course-ys/like-add', p)

export const apiChapterBbsList = (p) =>
  get('/api-web/course-ys/chapter-bbs-list', p)
export const apiChapterBbsAdd = (p) => get('/api-web/course-ys/chapter-bbs-add', p)

export const apiCourseCate = (p) => get('/api-web/course-ys/tag-list', p)

export const apiCourseOrder = (p) => post('/api-web/course-ys/pay-order-add', p)

export const apiCourseWechatPay = (p) => post('/api/pay/wx-h5-unify', p)

export const apiCourseAlipay = (p) => post('/api/pay/ali-h5-unify', p)

export const apiCoursePayCredit = (p) => post('/api/pay/pay-by-credit', p)

export const apiCourseLearn = (p) => post('/api-web/course-ys/learn-mark', p)

export const apiCourseBuyList = (p) => get('/api-web/course-ys/course-my-pay', p)

export const apiCourseHistoryList = (p) =>
  get('/api-web/course-ys/course-my-view', p)

export const apiCourseVipAudio = (p) => post('/api-web/course-ys/task-add', p)

export const apiCourseVipAudioList = (p) => get('/api-web/course-ys/task-list', p)

export const apiCourseAudioDel = (p) => post('/api-web/course-ys/task-del', p)

export const apiCourseTrySubmit = (p) =>
  post('/api-web/course-ys/task-mark-add', p)

export const apiCourseJobsTry = (p) =>
  get('/api-web/question/my-chapter-try-list', p)

// 一键报名
export const apisignUp = (p) =>
  post('/api-web/course-ys/sign-up', p)

// 资料题库列表
export const courseResList = (p) =>
  post('/api-web/course-ys/cate-res-list', p)

